import ExcelJS from 'exceljs';

export type SurveyWorkbookSheet = {
  name: string;
  rows: (string | number)[][];
};

export async function buildSurveyWorkbook(
  sheets: SurveyWorkbookSheet[],
): Promise<ArrayBuffer> {
  const workbook = new ExcelJS.Workbook();
  for (const sheet of sheets) {
    workbook.addWorksheet(sheet.name).addRows(sheet.rows);
  }
  const buffer = await workbook.xlsx.writeBuffer();
  return Uint8Array.from(new Uint8Array(buffer)).buffer;
}

export function downloadSurveyWorkbook(
  buffer: ArrayBuffer,
  filename: string,
): void {
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(url);
  }
}
